<template>
  <div id="app" class="app" ondragstart="return false">
    <router-view />
  </div>
</template>

<script>
export default {
  metaInfo: {
    title: "专家评审平台",
    htmlAttrs: {
      lang: "zh",
    },
  },
  mounted() {
    //配置提示框
    this.$message.config({
      top: `120px`,
    });
  },
};
</script>
<style lang="less">
* {
  padding: 0;
  margin: 0;
  list-style: none;
}
.app {
  font-size: 16px;
  ul {
    margin-bottom: 0;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: unset;
    font-weight: bold;
    margin-bottom: unset;
    margin-block-start: unset;
    margin-block-end: unset;
  }
  p {
    margin-bottom: 0;
  }
}
</style>
